(() => {
  if (customElements.get('liene-deal-products')) return;
  customElements.define('liene-deal-products', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const swatch = event.target.closest('[data-product-option]');
        if (swatch) this.selectProduct(swatch);
        const button = event.target.closest('[data-buy]');
        if (button) this.add(button);
      }, { signal: this.controller.signal });
    }

    selectProduct(swatch) {
      const card = swatch.closest('.ldp__card');
      if (card.querySelector('[data-buy]').hasAttribute('aria-busy')) return;
      const data = JSON.parse(swatch.dataset.productOption);
      card.querySelectorAll('[data-product-option]').forEach(item => item.setAttribute('aria-pressed', String(item === swatch)));
      card.querySelectorAll('[data-product-link]').forEach(link => { link.href = data.url; });
      card.querySelector('[data-title]').textContent = data.title;
      const description = card.querySelector('[data-description]');
      // HTML is rendered by Shopify; plain text sources are escaped in Liquid.
      if (typeof data.descriptionHtml === 'string') description.innerHTML = data.descriptionHtml;
      else description.textContent = data.description || '';
      if (data.clampDescription) description.setAttribute('data-clamp-description', '');
      else description.removeAttribute('data-clamp-description');
      card.querySelector('[data-price]').textContent = data.price;
      const compare = card.querySelector('[data-compare]');
      compare.textContent = data.compare;
      compare.hidden = !data.compare;
      const media = card.querySelector('.ldp__media');
      media.setAttribute('aria-label', data.title);
      let image = media.querySelector('img');
      if (data.image) {
        if (!image) { image = document.createElement('img'); image.className = 'ldp__image'; media.replaceChildren(image); }
        image.removeAttribute('srcset');
        image.src = data.image; image.alt = data.alt; image.hidden = false;
      } else { media.replaceChildren(); }
      const button = card.querySelector('[data-buy]');
      button.dataset.variantId = data.variant || '';
      button.dataset.url = data.url;
      button.dataset.plan = String(data.requiresPlan);
      button.disabled = !data.available;
      button.textContent = data.requiresPlan ? this.dataset.options : data.available ? this.dataset.buy : this.dataset.sold;
      const status = card.querySelector('.ldp__status');
      status.textContent = ''; status.removeAttribute('data-error');
    }

    async add(button) {
      if (button.disabled || !button.dataset.variantId) return;
      if (button.dataset.plan === 'true') { window.location.assign(button.dataset.url); return; }
      const card = button.closest('.ldp__card'), status = card.querySelector('.ldp__status');
      const swatches = [...card.querySelectorAll('[data-product-option]')];
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      swatches.forEach(swatch => { swatch.disabled = true; });
      status.textContent = '';
      status.removeAttribute('data-error');
      let added = false;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: button.dataset.variantId, quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        added = true;
        status.textContent = this.dataset.added;
        if (window.CustomCartDrawer?.open) window.CustomCartDrawer.open();
        else window.location.assign(`${root}cart`);
      } catch (error) {
        // A drawer failure must not suggest retrying an already successful add.
        status.textContent = added ? this.dataset.added : (error.message === 'Failed to fetch' ? this.dataset.error : error.message || this.dataset.error);
        if (!added) status.setAttribute('data-error', '');
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        swatches.forEach(swatch => { swatch.disabled = false; });
      }
    }

    disconnectedCallback() { this.controller.abort(); }
  });
})();
